document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.kh-menu-toggle');
  const menu = document.querySelector('.kh-main-nav');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.classList.toggle('is-open', !open);
    });
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const price = document.querySelector('[data-product-price]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
    });
  });

  document.querySelectorAll('.kh-product-description').forEach((description) => {
    const hasRichFormatting = description.querySelector('p, ul, ol, h2, h3, h4, br, table');
    if (!hasRichFormatting) description.classList.add('kh-product-description--plain');
  });
});


/* Product card galleries: controls never add a product to the cart. */
(() => {
  const initCardGalleries = (root = document) => {
    root.querySelectorAll('[data-card-gallery]').forEach((gallery) => {
      if (gallery.dataset.galleryReady) return;
      const link = gallery.querySelector('a.cs-product-card__image, a.kh-product-card__image');
      const controls = gallery.querySelector('[data-card-controls]');
      if (!link || !controls) return;
      const images = Array.from(link.querySelectorAll('img'));
      const templates = Array.from(gallery.querySelectorAll('template[data-card-photo]'));
      const total = images.length + templates.length;
      if (total < 2) return;
      gallery.dataset.galleryReady = 'true';
      gallery.classList.add('is-gallery-ready');
      const dots = gallery.querySelector('[data-card-dots]');
      const status = gallery.querySelector('[data-card-status]');
      let index = 0, manual = false, suppressClickUntil = 0, start = null;
      const initialCount = images.length;
      let requestedIndex = 0, requestId = 0;
      const ready = new Map();
      const prepare = (target) => {
        if (ready.has(target)) return ready.get(target);
        let image = images[target];
        if (!image) {
          const source = templates[target - initialCount];
          if (!source) return Promise.reject(new Error('Missing card photo'));
          image = source.content.firstElementChild.cloneNode(true);
          image.classList.add('cs-card-extra-image', 'kh-card-extra-image');
          image.setAttribute('aria-hidden', 'true');
          images[target] = image;
        }
        image.sizes = `${Math.ceil(link.getBoundingClientRect().width || 400)}px`;
        image.loading = 'eager';
        const promise = new Promise((resolve, reject) => {
          const loaded = async () => {
            try { if (image.decode) await image.decode(); } catch (_) {}
            if (image.naturalWidth) resolve(image);
            else reject(new Error('Card photo unavailable'));
          };
          if (image.complete && image.naturalWidth) loaded();
          else {
            image.addEventListener('load', loaded, {once:true});
            image.addEventListener('error', reject, {once:true});
          }
        });
        ready.set(target, promise);
        promise.catch(() => ready.delete(target));
        if (!image.isConnected) link.appendChild(image);
        return promise;
      };
      const prefetchNext = () => { prepare((index + 1) % total).catch(() => {}); };
      const show = async (target, announce = false) => {
        requestedIndex = (target + total) % total;
        const nextIndex = requestedIndex, ticket = ++requestId;
        link.setAttribute('aria-busy', 'true');
        try {
          await prepare(nextIndex);
          if (ticket !== requestId) return;
          images.forEach((image, i) => {if(image){image.classList.toggle('is-card-active', i === nextIndex);image.setAttribute('aria-hidden', String(i !== nextIndex));}});
          index = nextIndex;
          Array.from(dots.children).forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
          if (announce && status) status.textContent = `Photo ${index + 1} of ${total}`;
          prefetchNext();
        } catch (_) {
          if (ticket === requestId && announce && status) status.textContent = 'Photo could not load. Please try again.';
        } finally {
          if (ticket === requestId) link.removeAttribute('aria-busy');
        }
      };
      for (let i = 0; i < total; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';dot.setAttribute('aria-label', `Show photo ${i + 1} of ${total}`);
        dot.addEventListener('click', (event) => {event.preventDefault();event.stopPropagation();manual = true;show(i, true);});
        dots.appendChild(dot);
      }
      const navigate = (step) => {manual = true;show(requestedIndex + step, true);};
      gallery.querySelector('[data-card-previous]').addEventListener('click', (event) => {event.preventDefault();event.stopPropagation();navigate(-1);});
      gallery.querySelector('[data-card-next]').addEventListener('click', (event) => {event.preventDefault();event.stopPropagation();navigate(1);});
      link.addEventListener('keydown', (event) => {if(event.key === 'ArrowLeft' || event.key === 'ArrowRight'){event.preventDefault();navigate(event.key === 'ArrowLeft' ? -1 : 1);}});
      link.addEventListener('mouseenter', () => {if(!manual && matchMedia('(hover:hover) and (pointer:fine)').matches) show(1);});
      link.addEventListener('mouseleave', () => {if(!manual) show(0);});
      link.addEventListener('touchstart', (event) => {if(event.touches.length===1) start={x:event.touches[0].clientX,y:event.touches[0].clientY};},{passive:true});
      link.addEventListener('touchmove', (event) => {if(!start||event.touches.length!==1)return;const dx=event.touches[0].clientX-start.x,dy=event.touches[0].clientY-start.y;if(Math.abs(dx)>12&&Math.abs(dx)>Math.abs(dy))event.preventDefault();},{passive:false});
      link.addEventListener('touchend', (event) => {if(!start)return;const dx=event.changedTouches[0].clientX-start.x,dy=event.changedTouches[0].clientY-start.y;start=null;if(Math.abs(dx)>35&&Math.abs(dx)>Math.abs(dy)){suppressClickUntil=Date.now()+500;navigate(dx<0?1:-1);}},{passive:true});
      link.addEventListener('touchcancel',()=>{start=null;},{passive:true});
      link.addEventListener('click', (event) => {if(Date.now()<suppressClickUntil){event.preventDefault();event.stopPropagation();}});
      controls.hidden = false;show(0);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initCardGalleries());
  else initCardGalleries();
  document.addEventListener('shopify:section:load', (event) => initCardGalleries(event.target));
})();
